import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import FormBuilder from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfigMapper } from "./Compromisos.form";

interface Props {
  data: any;
  onUpdate: (data: any, hasError: boolean) => void;
  saveKey: number;
}

export default function CompromisosTable({ data, onUpdate, saveKey }: Props) {
  const [periodoAnterior, setPeriodoAnterior] = useState(false);

  useEffect(() => {
    if (data == null) {
      return;
    }

    // Periodo sin cambio de día
    const fechaPeriodo = new Date(`${data.periodo}T00:00:00Z`);
    const mesPeriodo = fechaPeriodo.getUTCMonth();
    const anioPeriodo = fechaPeriodo.getUTCFullYear();

    // Fecha actual
    const fechaActual = new Date();
    const mesActual = fechaActual.getMonth();
    const anioActual = fechaActual.getFullYear();

    // Periodo anterior
    setPeriodoAnterior(
      anioPeriodo < anioActual ||
        (anioPeriodo === anioActual && mesPeriodo < mesActual)
    );
  }, [data]);

  const handleFormChange = (values, hasError) => {
    const updatedData = {
      ...data,
      ...values
    };
    onUpdate(updatedData, hasError);
  };

  if (!data) {
    return null;
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover size="sm">
        <thead className="">
          <tr className="bg-dark text-white">
            <th colSpan={4} className="text-center">
              PUNTOS DE ALCANCE
            </th>
            <th colSpan={4} className="text-center">
              INGRESOS
            </th>
            <th colSpan={4} className="text-center">
              PROSPECTOS
            </th>
          </tr>
          <tr>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Presupuesto
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Compromiso
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Alcance
            </th>
            <th style={{ textAlign: "center", width: "4%", maxWidth: "4%" }}>
              % Pct
            </th>
            <th style={{ textAlign: "center", width: "15%", maxWidth: "15%" }}>
              Presupuesto
            </th>
            <th style={{ textAlign: "center", width: "16%", maxWidth: "16%" }}>
              Compromiso
            </th>
            <th style={{ textAlign: "center", width: "15%", maxWidth: "15%" }}>
              Alcance
            </th>
            <th style={{ textAlign: "center", width: "4%", maxWidth: "4%" }}>
              % Pct
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Presupuesto
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Compromiso
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Alcance
            </th>
            <th style={{ textAlign: "center", width: "4%", maxWidth: "4%" }}>
              % Pct
            </th>
          </tr>
        </thead>
        <tbody>
          <tr key={`${saveKey}-tracking-club`}>
            <FormBuilder<Inputs, Buttons>
              config={formConfigMapper(
                periodoAnterior,
                data.plantillaConfirmada
              )}
              init={{
                consolidadoPresupuesto: data.consolidadoPresupuesto,
                consolidadoCompromiso: data.consolidadoCompromiso,
                consolidadoActual: data.consolidadoActual,
                consolidadoAlcance: data.consolidadoAlcance,
                totalVentasPresupuesto: data.totalVentasPresupuesto,
                totalVentasCompromiso: data.totalVentasCompromiso,
                totalVentasActual: data.totalVentasActual,
                totalVentasAlcance: data.totalVentasAlcance,
                numeroProspectosPresupuesto: data.numeroProspectosPresupuesto,
                numeroProspectosCompromiso: data.numeroProspectosCompromiso,
                numeroProspectosActual: data.numeroProspectosActual,
                numeroProspectosAlcance: data.numeroProspectosAlcance
              }}
              onChange={handleFormChange}
              asTable={true}
            />
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
